import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import nestApiService from 'services/api/nest-api-service'

export interface SpreeAddress {
  id: number
  street: string
  complement: string
  city: string
  state: string
  zipcode: string
}

export interface AccountState {
  isLoading: boolean
  spreeAddress: SpreeAddress | null
}

const initialState: AccountState = {
  isLoading: false,
  spreeAddress: null
}

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    resetAccountState: (state) => {
      state = initialState
      return state
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(getSpreeAddress.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getSpreeAddress.fulfilled, (state, action) => {
        state.isLoading = false
        state.spreeAddress = action.payload
      })
      .addCase(getSpreeAddress.rejected, (state) => {
        state.isLoading = false
        state.spreeAddress = null
      })
})

export const { resetAccountState } = accountSlice.actions

export default accountSlice.reducer

interface GetSpreeAddressParams {
  userId: number
}

export const getSpreeAddress = createAsyncThunk(
  'get-spree-address',
  async (params: GetSpreeAddressParams, { rejectWithValue }) => {
    try {
      const { data } = await nestApiService.apiInstance.get<SpreeAddress>('/spree-address', {
        params
      })

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)

interface UpdateSpreeAddressParams {
  cep: string
  state: string
  city: string
  neighborhood: string
  street: string
  complement: string
  patientId: number
  spreeUserId: number
  addressId: number
}

export const updateSpreeAddress = createAsyncThunk(
  'update-spree-address',
  async (params: UpdateSpreeAddressParams, { rejectWithValue }) => {
    try {
      const { data } = await nestApiService.apiInstance.put<SpreeAddress>('/spree-address', params)

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
